import { coreEpisodes, resolveCoreEpisode } from '@/adapters/core/episodeCatalog';
import { coreEpisodeSupport } from '@/adapters/core/episodeSupport';
import { runtimeController } from '@/adapters/core/runtime';
import type { EpisodePresentation } from '@/_contract/types';
import type { Config, CosmosDataModel, RuntimeState } from '@/adapters/core/_contract/config';

export const episodePresentation: EpisodePresentation<Config, RuntimeState, CosmosDataModel> = {
    support: coreEpisodeSupport,
    episodes: coreEpisodes,
    enter: (args) => {
        return runtimeController.reduceOverlayIntent!({
            config: args.config,
            runtimeState: args.runtimeState,
            cosmosData: args.cosmosData,
            intent: { overlayIntentKind: 'select-changed', sectionId: 'core-episode-selector', value: args.handle },
        });
    },
    detach: (state) => ({ ...state, episode: undefined, sceneIndex: undefined }),
    playback: (state) => state.episode,
    inspectPlan: (state) => {
        if (!state.episode) throw new Error('No active Core episode.');
        const { scene } = resolveCoreEpisode(state.episode.episodeHandle, state.sceneIndex ?? 0);
        return scene;
    },
    pause: (state) => ({
        ...state,
        episode: state.episode ? { ...state.episode, isPlaying: false, narrationRequested: false } : undefined,
    }),
    settled: () => true,
    overlay: (model) => ({
        ...model,
        sections: model.sections.filter((s) => s.sectionId !== 'core-episode-selector'),
    }),
};
